import _ from 'lodash';

const word_name = ["doc", "docx", "docm", "dotm", "dotx"];
const ppt_name = ["pptx", "ppsx", "ppt", "pps", "pptm", "potm", "ppam", "potx", "ppsm"];
const excel_name = ["xlsx", "xlsb", "xls", "xlsm"];
const word_type = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
const ppt_type = ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"];
const excel_type = ["application/x-msi", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

function getChild(children, id) {
	let child;
	children && children.map((i) => {
		if (i.id === id) {
			child = i;
		} else {
			child = child || getChild(i.childs, id);
		}
	});
	return child;
}

export function getParents(tree, id, prefix) {
	let parents = [];
	parents.push({ to: '/', name: '首页' });
	let child = getChild(tree, id);
	child && child.parents && child.parents.map((i) => {
		if (i && i.parents && i.parents.length > 0) {
			let res = i.childs && i.childs.filter((c) => {
				return c.type === 'category';
			});
			parents.push({ to: res && res.length > 0 ? `/${prefix}/${i.id}/` : `/${prefix}/${i.id}/list`, name: i.name });

		} else {
			parents.push({ to: `/${prefix}`, name: i.name });
		}
	});
	return parents;
}


export function items2CollectionItems(items) {
	if (items.constructor !== Array) {
		items = [items];
	}

	const collectionItmes = items.map((item, index) => {
		let _item = item.type === 'asset' ? {
			type: 'file',
			asset: {
				_id: item._id,
				current: item.current,
				space: item.space,
				acl: item.acl || {
					read: [1],
					shareable: true,
					downloadable: true
				}
			}
		} : {
				type: 'link',
				title: item.name || item.title || '',
				thumbnail: _.get(item, 'cover.current.thumbnail') || _.get(item, 'cover.thumbnail'),
				href: item.href ? removeNativeUrl(item.href) : resourceUrl(item),
				resourceId: item._id,
				resourceType: item.type,
				acl: item.acl || {
					read: [1],
					shareable: true
				}
			};
		return _item;
	})

	return collectionItmes;
}

function removeNativeUrl(url) {
	// 需要把 url 的 via=native_home 删除掉
	url = url.replace('?via=native_home', '');
	url = url.replace('&via=native_home', '');
	url = url.replace('via=native_home', '');
	return url;
}

function resourceUrl(item) {
	const id = item._id;
	const url = window.location.protocol + '//' + window.location.host;
	if (item.categories === undefined && item.products === undefined) {
		return url + '/products/detail/' + id;
	}
	if ((item.categories === undefined || item.categories.length === 0) && item.products) {
		return url + '/products/' + id + '/list';
	}
	return url + '/products/' + id;

	// switch (item.type) {
	// case 'category':
	// 	if (item.categories && item.categories.length > 0) {
	// 		return url + '/products/' + id;
	// 	} else {
	// 		return url + '/products/' + id + '/list';
	// 	}
	// 	break;
	// case 'product':
	// 	return url + '/products/detail/' + id;
	// 	break;
	// 	// case 'folder':
	// 	// 	type = 'downloads';
	// 	// 	break;
	// 	// case 'article':
	// 	// 	type = 'article';
	// 	// 	break;
	// 	// case 'topic':
	// 	// 	type = 'articles';
	// 	// 	break;
	// }
}

// get assets/product object cover image
export function getCover(item = {}) {
	let cover = _.get(item, 'cover.thumbnail') || _.get(item, 'cover.current.thumbnail') || _.get(item, 'current.thumbnail');
	// 使用 1px 的透明图做占位
	return cover || (item.type === 'asset' ? getFileIcon(item) : undefined) || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
}

// get object name
export function getName(itemObj = {}) {
	let nameStr;

	if (itemObj.type === 'asset') {
		nameStr = (itemObj.current && itemObj.current.name) || '';
	} else {
		nameStr = itemObj.name
	}

	return nameStr;
}

export function getFileIcon(item) {
	const fileName = item.current.fileName;
	const mimeType = _.get(item, 'current.mimeType');

	if (/.pptx?$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/ppt.png'
	} else if (/.psd$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/psd.png'
	} else if (/.rar$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/rar.png'
	} else if (/.docx?$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/word.png'
	} else if (/.xls$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/xls.png'
	} else if (/.zip$/.test(fileName)) {
		return process.env.PUBLIC_PATH + '/static/icons/zip.png'
	} else {
		const type = isOffice(mimeType, fileName);
		if('word' === type) {
			return process.env.PUBLIC_PATH + '/static/icons/word.png'
		} else if('ppt' === type) {
			return process.env.PUBLIC_PATH + '/static/icons/ppt.png'
		} else if('excel' === type) {
			return process.env.PUBLIC_PATH + '/static/icons/xls.png'
		} else {
			return process.env.PUBLIC_PATH + '/static/icons/unsupport.png'
		}
  	}
}

function isOffice(mimeType, fileName) {
  if (mimeType.indexOf('zip') >= 0) {
      return checkName(fileName);
  } else {
      return checkType(mimeType, fileName);
  }
}

function checkName(fileName) {
  const index = fileName.indexOf('.');
  if (index < 0) return '';
  const type = fileName.substring(index + 1);
  if (checkIfContains(word_name, type)) return 'word';
  if (checkIfContains(ppt_name, type)) return 'ppt';
  if (checkIfContains(excel_name, type)) return 'excel';
  return '';
}

function checkType(mimeType, fileName) {
  if (checkIfContains(word_type, mimeType)) return 'word';
  if (checkIfContains(ppt_type, mimeType)) return 'ppt';
  if (checkIfContains(excel_type, mimeType)) return 'excel';
  return '';
}

function checkIfContains(arr, value) {
  for (var i = 0; i < arr.length; i++) {
      if (arr[i] == value) return true;
  }
  return false;
}

export function getTimestamp(time) {
	var date = new Date(time);
	return date.getTime();
}

export const isiPad = () =>  {
  let _isiPad = false

  let ua = window.navigator.userAgent
  let isIOS = ((((((((((((((((((((((((((((((((((((((((/iPhone|iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) && !window['x5mtt']

  let isiPhone = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPhone/i)))))))))))))))))))))))))))))))))))))))).test(ua)
  _isiPad = isIOS && ((((((((((((((((((((((((((((((((((((((((/iPad/i)))))))))))))))))))))))))))))))))))))))).test(ua) &&
    (screen.width * screen.height === 1024 * 768 ||
      (Math.round(screen.width / screen.height * 1000) / 1000 > 1.330 && Math.round(screen.width / screen.height * 1000) / 1000 < 1.340) ||
      (Math.round(screen.height / screen.width * 1000) / 1000 > 1.330 && Math.round(screen.height / screen.width * 1000) / 1000 < 1.340)
    )

  let screenResolutionCheck1 = (Math.round(screen.width / screen.height * 1000) / 1000) === 0.667;
  let screenResolutionCheck2 = (Math.round(screen.height / screen.width * 1000) / 1000) === 1.5
  if(isiPhone && screenResolutionCheck1 && screenResolutionCheck2) {
    // fixed for iPad Pro 12.9 inch
    isiPhone = false;
    _isiPad = true;
  }

  return _isiPad
}
